import React, {useEffect, useState} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { 
    Container, 
    Row, Col, Card, 
    CardBody, CardTitle, Table,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem, Modal, Alert, Input, Button, Badge} from "reactstrap";
    import { Link } from 'react-router-dom';

import Breadcrumbs from "../../components/Common/Breadcrumb";
import * as url from "../../helpers/url_helper"
import axios from 'axios';
import { formatDate, HRConfig, TOAST_OPTIONS } from './../../helpers/backend_helper';

import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import PropTypes from "prop-types";

    const TrainingPlan = () => {
        const [dCases, setDCases] = useState([])
        const [modal, setmodal] = useState(false);
        const [modal_details, setmodal_details] = useState(false);
        const [isLoading, setIsLoading] = useState(false)
        const [empNo, setEmpNo] = useState('')
        const [empName, setEmpName] = useState('')
        const [empTitle, setEmpTitle] = useState('')
        const [postingDate, setPostingDate] = useState(new Date())
        const [skills, setSkills] = useState([])
        const [details, setDetails] = useState(null)
        const [courses, setCourses] = useState([])
        const [conferences, setConferences] = useState([])
        const [certificates, setCertificates] = useState([])
        const [coaching, setCoaching] = useState([])
        const [startDateTime, setStartDateTime] = useState(new Date())
        const [endDateTime, setEndDateTime] = useState(new Date())
        const [types, setTypes] = useState(['Course','Certificate', 'Coaching','Conference'])
        const [tGroups, setTGroups] = useState([])
        const [accounts, setAccounts] = useState([])
        const [budgets, setBudgets] = useState([])
        const [venue, setVenue] = useState([])
        const [emp, setEmp] = useState(null)
        const [show, setShow] = useState('Course')
        const [selectedAccount, setSelectedAccount] = useState(null)
        const [selectedBudget, setSelectedBudget] = useState(null)

        toastr.options = TOAST_OPTIONS;

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_case = () => {
            setmodal(!modal);
            removeBodyCss();
        }
        const tog_details = () => {
            setmodal_details(!modal_details);
            removeBodyCss();
        }

        const [rows1, setrows1] = useState([{ id: 1 }]);

        const [formRows, setFormRows] = useState([{ id: 1 }]);

        const onAddFormRow = () => {
            const modifiedRows = [...formRows];
            modifiedRows.push({ id: modifiedRows.length + 1 });
            setFormRows(modifiedRows);
        };

        const onDeleteFormRow = id => {
            if (id !== 1) {
            var modifiedRows = [...formRows];
            modifiedRows = modifiedRows.filter(x => x["id"] !== id);
            setFormRows(modifiedRows);
            }
        };
        const handleTypeChange = (e) =>{
            if(e == 'Course'){
                setShow('Course')
            }else if(e == 'Certificate'){
                setShow('Certificate')
            }else if(e == 'Conference'){
                setShow('Conference')
            }else if(e == 'Coaching'){
                setShow('Coaching')
            }
        }
        const handleClickDetails = (t) =>{
            setDetails(t)
            console.log(t)
            tog_details();
        }
        const handleCancelApproval = () =>{
            const data = {
                no: details.No
            }
            setIsLoading(true)
            axios.post(url.PDPCANCELAPPROVAL, data, HRConfig).then((r)=>{
                if(r.request.status == '204'){
                    toastr.success("Personal Development Plan Approval Cancelled")
                    tog_details()
                    getData()
                }else{
                    toastr.error("Could not Cancel")
                }
                setIsLoading(false)
            }).catch((e)=>{
                console.log(e)
                toastr.error(e.response.data.error.message)
                setIsLoading(false)
            })
        }
        const handleSubmit2Approve = () =>{
            const data = {
                no: details.No
            }
            setIsLoading(true)
            axios.post(url.PDPAPPROVAL, data, HRConfig).then((r)=>{
                if(r.request.status == '204'){
                    toastr.success("Personal Development Plan Sent For Approval")
                    tog_details()
                    getData()
                }else{
                    toastr.error("Could not Send Personal Development Plan For Approval")
                }
                setIsLoading(false)
            }).catch((e)=>{
                console.log(e)
                toastr.error(e.response.data.error.message)
                setIsLoading(false)
            })
        }
        const handleSubmit = () =>{
            const planLs = [];
            
            for(let i = 0; i < formRows.length; i++){
                const plan = {
                    CourseCode:  document.getElementsByClassName('courseCode')[i].value,
                    ExpectedParticipants:  parseInt(document.getElementsByClassName('expectedParticipants')[i].value),
                    EstimatedUnitCost:  parseInt(document.getElementsByClassName('unitCost')[i].value),
                }
                planLs.push(plan);
            }
            const data = {
                Type: show,
                TargetParticipants: document.getElementsByClassName('targetParticipants')[0].value,
                TrainingExpenseAccount: selectedAccount,
                BudgetName: selectedBudget,
                ShortcutDimension1Code: emp.GlobalDimension1Code,
                ShortcutDimension2Code: emp.GlobalDimension2Code,
                CapacityGapstobefilled: document.getElementsByClassName('capacityGap')[0].value,
                TrainingVenue: document.getElementsByClassName('trainingVenue')[0].value,
                SourceofFunding: document.getElementsByClassName('sourceOfFunding')[0].value,
                OtherRemarks: document.getElementsByClassName("oRemarks")[0].value,
                PlannedStartDate: startDateTime[0].toISOString().substr(0, 10),
                PlannedStartTime:startDateTime[0].toLocaleTimeString(),
                DurationofTraining: `${Math.floor((endDateTime[0] - startDateTime[0]) / (1000 * 60 * 60 * 24))}D`,
                trainingPlanLines:planLs
            }
            console.log(JSON.stringify(data))
            setIsLoading(true)
            axios.post(url.TRAININGPLAN, data, HRConfig).then((r)=>{
                if(r.request.status == '201'){
                    toastr.success("Training Plan Saved, You can submit for Approval")
                    tog_case()
                    getData()
                }else{
                    toastr.error("Could not Create Training Plan")
                }
                setIsLoading(false)
            }).catch((e)=>{
                console.log(e)
                toastr.error(e.response.data.error.message)
                setIsLoading(false)
            })
           
        }

        const getData = () =>{
            setIsLoading(true)
            if (localStorage.getItem("authUser")) {
                const obj = JSON.parse(localStorage.getItem("authUser"));
                setEmpNo(obj.uid)
                setEmpName(obj.username)
                axios.get(`${url.EMPLOYEES}?$filter=No eq '${obj.uid}'`, HRConfig).then((r)=>{ 
                    setEmpTitle(r.data.value[0].JobTitle) 
                    setEmp(r.data.value[0])
                }).catch((e)=>{ console.log(e)})
            }
            axios.get(url.TRAININGPLANEXPAND, HRConfig).then((r)=>{ 
                setIsLoading(false)
                setDCases(r.data.value)
                console.log(r.data.value)
            }).catch((e)=>{ console.log(e); setIsLoading(false); }) 
    
            axios.get(url.COURSES, HRConfig).then((r)=>{ 
                setCourses(r.data.value)
            }).catch((e)=>{ console.log(e) })
            axios.get(url.CERTIFICATES, HRConfig).then((r)=>{ 
                setCertificates(r.data.value)
            }).catch((e)=>{ console.log(e) })
            axios.get(url.CONFERENCES, HRConfig).then((r)=>{ 
                setConferences(r.data.value)
            }).catch((e)=>{ console.log(e) })
            axios.get(url.COACHING, HRConfig).then((r)=>{ 
                setCoaching(r.data.value)
            }).catch((e)=>{ console.log(e) })
            axios.get(url.TRAININGGROUPS, HRConfig).then((r)=>{ 
                setTGroups(r.data.value)
            }).catch((e)=>{ console.log(e) })
            axios.get(url.ACCOUNTS, HRConfig).then((r)=>{ 
                
                let options = []
                r.data.value.map((r)=>{
                    options.push({label:r.Name, value: r})
                })
                setAccounts(options)
            }).catch((e)=>{ console.log(e) })
            axios.get(url.BUDGETS, HRConfig).then((r)=>{ 
                let options = []
                r.data.value.map((r)=>{
                    options.push({label:r.Description, value: r})
                })
                setBudgets(options)
            }).catch((e)=>{ console.log(e) })
            axios.get(url.VENUES, HRConfig).then((r)=>{ 
                setVenue(r.data.value)
            }).catch((e)=>{ console.log(e) })
        }
        useEffect(()=>{
           getData()
        },[])
        const { SearchBar } = Search;
        const columns = [
            {
              dataField: 'No',
              text: 'No',
              sort: true,
              formatter: noFormatter
            },
            {
                dataField: 'Type', 
                text: 'Type',
                sort: true
              }, 

              {
                dataField: 'CapacityGapstobefilled', 
                text: 'Gap To Be filled',
                sort: true
              },    {
              dataField: 'TargetParticipants', 
              text: 'Participants',
              sort: true
            }, 
            {
                dataField: 'TrainingVenue',
                text: 'Venue',
                sort: true,
              }, 
              {
                dataField: 'DurationofTraining',
                text: 'Duration',
                sort: true,
              }, 
            {
              dataField: 'PlannedStartDate',
              text: 'Start Date',
              sort: true
            }, 
            {
                dataField: 'TotalCost',
                isDummyField: true,
                text: 'Cost',
                sort: true,
                formatter: costFormatter
              },
            {
                dataField: 'trainingPlanLines',
                isDummyField: true,
                text: 'Plans',
                sort: true,
                formatter: planFormatter
              },
            {
              dataField: "action",
              isDummyField: true,
              text: "",
              formatter: actionFormatter
            }];
      
            const defaultSorted = [{
              dataField: 'No',
              order: 'desc'
            }];
      
            function planFormatter(cellContent,row){
              return(
                <span> <strong>{row.trainingPlanLines.length}</strong></span>
              )
            }
            function raisedByFormatter(cellContent,row){
                return(
                  <span> {row.EmployeeName}<br/>{row.EmployeeNo}</span>
                )
              }
            function costFormatter(cellContent, row){
              return(
                <span> {row.TotalCost.toLocaleString("en-US", {
                    style: "currency",
                    currency: "UGX"
                  })
                }</span>
              )
            }
            function noFormatter(cellContent, row){
              return(
                <strong>{cellContent}</strong>
              )
            }
      
            function actionFormatter(cellContent, row){
              return(
                <>
                <div className="d-flex gap-3">
                <UncontrolledDropdown direction="left">
                    <DropdownToggle href="#" className="card-drop" tag="i">
                      <i className="mdi mdi-dots-horizontal font-size-18" />
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                 
                      <DropdownItem
                        onClick={() => { handleClickDetails(row); }}
                      >
                        <i className="fas fa-address-card text-warning me-1" />
                        View Training Plan Details
                      </DropdownItem>
                     
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </>
              )
            }
            function statusFormatter(cellContent, row) {
              if (row.Status == "Open") {
                return (
                  <div>
                      <Badge className="me-2 bg-danger">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }else if (row.Status == "Approved"){
                return (
                  <div>
                      <Badge className="me-2 bg-success">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }else if (row.Status == "Withdrawn(Cancelled)"){
                return (
                  <div>
                      <Badge className="me-2 bg-secondary">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }else{
                return (
                  <div>
                      <Badge className="me-2 bg-warning">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }
            }
        
        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Training Plan | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Training Plan" />
                        <Row>
                        <Col lg={12}>
                                {isLoading ? (<Alert  color="danger" role="alert">Please wait...</Alert>) : null}
                            </Col>
                        <Col xl={12}>
                            <Card>
                                <CardBody>
                                
                                <Modal
                                  isOpen={modal}
                                  toggle={() => { tog_case()  }}
                                  size="xl"
                                  centered
                                  backdrop={'static'}
                                >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Create Training Plan` }</h5>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setmodal(false);
                                      }}
                                      className="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                    <Col lg={12}>
                                        {isLoading ? (<Alert  color="danger" role="alert">Please wait...</Alert>) : null}
                                    </Col>
                                    <Col sm={12} className="mb-3">
                                        <Row>
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <input name='EmployeeNo' id="EmployeeNo" type="text" className="form-control" disabled={true}  defaultValue = {empNo} />
                                            <label htmlFor="floatingIdInput">Employee No</label>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <input name='EmployeeName' id="EmployeeName"  type="text" className="form-control" disabled={true} defaultValue={empName} />
                                            <label htmlFor="floatingnameInput">Employee Name</label>
                                            </div>
                                        </Col>
                                      
                                
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <input name='Title' id="Title"  type="text" className="form-control" disabled={true} defaultValue={empTitle} />
                                            <label htmlFor="floatingDepartInput">Title</label>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <select className="form-select" onChange={(e)=>{handleTypeChange(e.target.value)}}>{types.map((t,k)=>(<option key={k} value={t}>{t}</option>))}</select>
                                            <label htmlFor="floatingDepartInput">Type</label>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <select className="form-select targetParticipants">{tGroups.map((g,k)=>(<option key={k} value={g.Code}>{g.Description}</option>))}</select>
                                            <label htmlFor="floatingDepartInput">Target Participants</label>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <input type="text" className="form-select" defaultValue={emp && emp.GlobalDimension1Code} disabled={true} />
                                            <label htmlFor="floatingDepartInput">Cost Center Code</label>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="form-floating mb-3">
                                            <input type="text" className="form-select"  defaultValue={emp && emp.GlobalDimension2Code} disabled={true}  />
                                            <label htmlFor="floatingDepartInput">Project Code</label>
                                            </div>
                                        </Col>
                                       
                                        <Col md={6}>
                                            <Select  options={accounts} className="mb-3" isClearable={true} isSearchable={true} placeholder="Select Account" 
                                                    onChange={(x)=>{setSelectedAccount(x.value.No)}}/>
                                        </Col>
                                        <Col md={6}>
                                            <Select  options={budgets} className="mb-3" isClearable={true} isSearchable={true} placeholder="Select Budget"
                                                    onChange={(x)=>{setSelectedBudget(x.value.Name) }}
                                            />
                                        </Col>
                                       
                                      
                                        <Col md={6}>
                                            <div className="form-floating mb-3">
                                            <input type="text" className="form-control capacityGap"  />
                                            <label htmlFor="floatingDepartInput">Capacity Gap to be filled</label>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <select className="form-select trainingVenue">{venue.map((t,k)=>(<option key={k} value={t.Code}>{t.Name}</option>))}</select>
                                            <label htmlFor="floatingDepartInput">Training Venue</label>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <input type="text" className="form-control sourceOfFunding" defaultValue={'Budget'}  />
                                            <label htmlFor="floatingDepartInput">Source of funding</label>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="form-floating mb-3">
                                            <input type="text" className="form-control oRemarks"  />
                                            <label htmlFor="floatingDepartInput">Other Remarks</label>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <Flatpickr
                                                className="form-control"
                                                placeholder="dd M,yyyy  hh:mm ss"
                                                options={{
                                                    dateFormat: "Y-m-d  H:i", enableTime: true,
                                                    defaultDate: startDateTime
                                                }}
                                                onChange={(d)=>{setStartDateTime(d)}}
                                                />
                                            <label htmlFor="floatingDepartInput">Planned Start Date and Time</label>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <Flatpickr
                                                className="form-control"
                                                placeholder="dd M,yyyy hh:mm ss"
                                                options={{
                                                    dateFormat: "Y-m-d  H:i", enableTime: true,
                                                    defaultDate: endDateTime
                                                }}
                                                onChange={(d)=>{setEndDateTime(d)}}
                                                />
                                            <label htmlFor="floatingDepartInput">Planned End Date and Time</label>
                                            </div>
                                        </Col>
                                        </Row>
                                    </Col>
                                    <Col  xl={12}>
                       
                                
                       <div>
                               {(formRows || []).map((formRow, key) => (
                           <span key={key}>
        
                           <strong className='mb-2'>Training Plan Line {formRow.id}</strong> 
                                   <Row >
                                   
                               
               
                                   <Col lg={6} className="mb-3">
                                   {(show == 'Course') && (
                                    <div className="form-floating mb-3">
                                        <select className='form-select courseCode'>{courses.map((c,k)=>(<option key={k} value={c.Code}>{c.Description}</option>))}</select> 
                                        <label htmlFor="floatingSelectGrid">Course Name</label>
                                    </div>
                                   )}
                                   {(show == 'Certificate') && (
                                    <div className="form-floating mb-3">
                                        <select className='form-select courseCode'>{certificates.map((c,k)=>(<option key={k} value={c.Code}>{c.Description}</option>))}</select> 
                                        <label htmlFor="floatingSelectGrid">Certificate Name</label>
                                    </div>
                                   )}
                                   {(show == 'Conference') && (
                                    <div className="form-floating mb-3">
                                        <select className='form-select courseCode'>{conferences.map((c,k)=>(<option key={k} value={c.Code}>{c.Description}</option>))}</select> 
                                        <label htmlFor="floatingSelectGrid">Conference Name</label>
                                    </div>
                                   )}
                                   {(show == 'Coaching') && (
                                    <div className="form-floating mb-3">
                                        <select className='form-select courseCode'>{coaching.map((c,k)=>(<option key={k} value={c.Code}>{c.Description}</option>))}</select> 
                                        <label htmlFor="floatingSelectGrid">Coaching Name</label>
                                    </div>
                                   )}
                                   </Col>
                                  
                                   <Col lg={2} className="mb-3">
                                   <div className="form-floating ">
                                   <input type="number" className='form-control expectedParticipants' />
                                       <label htmlFor="floatingSelectGrid">Expected Participants</label>
                                   </div>
                                   </Col>
                                   
                                   <Col lg={2} className="mb-3">
                                   <div className="form-floating">
                                       <input type="number" className='form-control unitCost' />
                                       <label htmlFor="floatingSelectGrid">Estimated Unit Cost</label>
                                   </div>
                                   </Col>
                                   

                             
                                   <Col lg={2} className="align-self-center">
                                       <div className="form-floating mb-3">
                                       
                                       <input
                                           type="button"
                                           className="btn btn-primary"
                                           value="Remove"
                                           onClick={() => onDeleteFormRow(formRow.id)}
                                       />
                                       </div>
                                   </Col>
                                   </Row>
                                  </span>
                               ))}
                               <Row>
                                   <Col md={6}>
                                   <div className="d-grid gap-2">
                                       <input
                                           type="button"
                                           className="btn btn-success mt-3 mt-lg-0"
                                           value="Add Training Plan Line"
                                           onClick={() => onAddFormRow()}
                                       />
                                   </div>
                                   </Col>
                                   <Col md={6}>
                                       <div className="d-grid gap-2">
                                           <Button color="primary" type="button" className="btn" onClick={handleSubmit} >
                                               Submit Training Plan
                                           </Button>
                                       </div>
                                   </Col>
                                   </Row>
                                   </div>
                                  
                                   
             
                                   
           
                                </Col>
                                  </Row>  
                                 
                                   
                                  </div>
                                 
                                </Modal>


                                <Modal
                                  isOpen={modal_details}
                                  toggle={() => { tog_details()  }}
                                  size="xl"
                                  centered
                                  backdrop={'static'}
                                >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Training Plan` }</h5>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setmodal_details(false);
                                      }}
                                      className="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                                         
                                    {details && (
                                        <>
                                    
                                        <Row>
                                    <Col lg={12}>
                                        {isLoading ? (<Alert  color="danger" role="alert">Please wait...</Alert>) : null}
                                    </Col>
                                    <Col sm={12} className="mb-3">
                                        <Row>
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <input name='EmployeeNo' id="EmployeeNo" type="text" className="form-control" disabled={true}  defaultValue = {details.EmployeeNo} />
                                            <label htmlFor="floatingIdInput">Employee No</label>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <input name='EmployeeName' id="EmployeeName"  type="text" className="form-control" disabled={true} />
                                            <label htmlFor="floatingnameInput">Employee Name</label>
                                            </div>
                                        </Col>
                                      
                                
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <input name='Title' id="Title"  type="text" className="form-control" disabled={true}  />
                                            <label htmlFor="floatingDepartInput">Title</label>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <select className="form-select" onChange={(e)=>{handleTypeChange(e.target.value)}}>{types.map((t,k)=>(<option key={k} value={t}>{t}</option>))}</select>
                                            <label htmlFor="floatingDepartInput">Type</label>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <select className="form-select targetParticipants">{tGroups.map((g,k)=>(<option key={k} value={g.Code}>{g.Description}</option>))}</select>
                                            <label htmlFor="floatingDepartInput">Target Participants</label>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <input type="text" className="form-select" defaultValue={emp && emp.GlobalDimension1Code} disabled={true} />
                                            <label htmlFor="floatingDepartInput">Cost Center Code</label>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="form-floating mb-3">
                                            <input type="text" className="form-select"  defaultValue={emp && emp.GlobalDimension2Code} disabled={true}  />
                                            <label htmlFor="floatingDepartInput">Project Code</label>
                                            </div>
                                        </Col>
                                       
                                        <Col md={6}>
                                            <Select  options={accounts} className="mb-3" isClearable={true} isSearchable={true} placeholder="Select Account" 
                                                    onChange={(x)=>{setSelectedAccount(x.value.No)}}/>
                                        </Col>
                                        <Col md={6}>
                                            <Select  options={budgets} className="mb-3" isClearable={true} isSearchable={true} placeholder="Select Budget"
                                                    onChange={(x)=>{setSelectedBudget(x.value.Name) }}
                                            />
                                        </Col>
                                       
                                      
                                        <Col md={6}>
                                            <div className="form-floating mb-3">
                                            <input type="text" className="form-control capacityGap"  />
                                            <label htmlFor="floatingDepartInput">Capacity Gap to be filled</label>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <select className="form-select trainingVenue">{venue.map((t,k)=>(<option key={k} value={t.Code}>{t.Name}</option>))}</select>
                                            <label htmlFor="floatingDepartInput">Training Venue</label>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <input type="text" className="form-control sourceOfFunding" defaultValue={'Budget'}  />
                                            <label htmlFor="floatingDepartInput">Source of funding</label>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="form-floating mb-3">
                                            <input type="text" className="form-control oRemarks"  />
                                            <label htmlFor="floatingDepartInput">Other Remarks</label>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <Flatpickr
                                                className="form-control"
                                                placeholder="dd M,yyyy  hh:mm ss"
                                                options={{
                                                    dateFormat: "Y-m-d  H:i", enableTime: true,
                                                    defaultDate: startDateTime
                                                }}
                                                onChange={(d)=>{setStartDateTime(d)}}
                                                />
                                            <label htmlFor="floatingDepartInput">Planned Start Date and Time</label>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-floating mb-3">
                                            <Flatpickr
                                                className="form-control"
                                                placeholder="dd M,yyyy hh:mm ss"
                                                options={{
                                                    dateFormat: "Y-m-d  H:i", enableTime: true,
                                                    defaultDate: endDateTime
                                                }}
                                                onChange={(d)=>{setEndDateTime(d)}}
                                                />
                                            <label htmlFor="floatingDepartInput">Planned End Date and Time</label>
                                            </div>
                                        </Col>
                                        </Row>
                                    </Col>
                                    <Col  xl={12}>
                       
                                
                       <div>
                               {(formRows || []).map((formRow, key) => (
                           <span key={key}>
        
                           <strong className='mb-2'>Training Plan Line {formRow.id}</strong> 
                                   <Row >
                                   
                               
               
                                   <Col lg={6} className="mb-3">
                                   {(show == 'Course') && (
                                    <div className="form-floating mb-3">
                                        <select className='form-select courseCode'>{courses.map((c,k)=>(<option key={k} value={c.Code}>{c.Description}</option>))}</select> 
                                        <label htmlFor="floatingSelectGrid">Course Name</label>
                                    </div>
                                   )}
                                   {(show == 'Certificate') && (
                                    <div className="form-floating mb-3">
                                        <select className='form-select courseCode'>{certificates.map((c,k)=>(<option key={k} value={c.Code}>{c.Description}</option>))}</select> 
                                        <label htmlFor="floatingSelectGrid">Certificate Name</label>
                                    </div>
                                   )}
                                   {(show == 'Conference') && (
                                    <div className="form-floating mb-3">
                                        <select className='form-select courseCode'>{conferences.map((c,k)=>(<option key={k} value={c.Code}>{c.Description}</option>))}</select> 
                                        <label htmlFor="floatingSelectGrid">Conference Name</label>
                                    </div>
                                   )}
                                   {(show == 'Coaching') && (
                                    <div className="form-floating mb-3">
                                        <select className='form-select courseCode'>{coaching.map((c,k)=>(<option key={k} value={c.Code}>{c.Description}</option>))}</select> 
                                        <label htmlFor="floatingSelectGrid">Coaching Name</label>
                                    </div>
                                   )}
                                   </Col>
                                  
                                   <Col lg={3} className="mb-3">
                                   <div className="form-floating ">
                                   <input type="number" className='form-control expectedParticipants' />
                                       <label htmlFor="floatingSelectGrid">Expected Participants</label>
                                   </div>
                                   </Col>
                                   
                                   <Col lg={3} className="mb-3">
                                   <div className="form-floating">
                                       <input type="number" className='form-control unitCost' />
                                       <label htmlFor="floatingSelectGrid">Estimated Unit Cost</label>
                                   </div>
                                   </Col>
                                   

                             
                                  
                                   </Row>
                                  </span>
                               ))}
                               <Row>
                    
                                   <Col md={12}>
                                       <div className="d-grid gap-2">
                                           <Button color="danger" type="button" className="btn"  >
                                               Send Approval request
                                           </Button>
                                       </div>
                                   </Col>
                                   </Row>
                                   </div>
                                  
                                   
             
                                   
           
                                </Col>
                                  </Row>  
                                 
                                        </>
                                    )}
                                    
                                  </Row>  
                                 
                                   
                                  </div>
                                  
                                </Modal>

                  
                               {(dCases.length > 0) && (<>

                                    <ToolkitProvider
                                        keyField="No"
                                        data={ dCases }
                                        columns={ columns }
                                        search
                                        >
                                        { toolkitProps => (
                                            <React.Fragment>
                                                <Row className='mb-5'>
                                                  <Col lg={9}>
                                                  <div  className="rounded bg-light d-grid gap-2">
                                           
                                                      <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                                 
                                                    </div>
                                                  </Col>
                                            
                                                  <Col lg={3}> 
                                                  <div className="d-grid gap-2">
                                                    <Link
                                                      className="btn btn-primary"
                                                      to="#"
                                                      onClick={()=>{tog_case()}}
                                                    >
                                                      <i className="mdi mdi-plus me-1" />
                                                      Create Training Plan
                                                    </Link>
                                                  </div>
                                                  </Col>
                                                </Row>
                                                <Row>
                                                <Col xl="12">
                                                    <div className="table">
                                                
                                                    <BootstrapTable 
                                                    keyField='No' 
                                                    data={ dCases } 
                                                    columns={ columns } 
                                                    striped
                                                    hover
                                                    condensed
                                                    bordered={ false }
                                                    noDataIndication="No Records" 
                                                    defaultSorted={ defaultSorted }
                                                    classes={ "table align-middle table-nowrap table-check" }
                                                        {...toolkitProps.baseProps}
                                                    />
                                                </div>
                                                </Col>
                                                </Row>
                                                </React.Fragment>
                                                
                                        )
                                        }
                                    </ToolkitProvider>
                  

                              
                                </>)}
                                {(dCases.length < 1) && (<>
                                    <Row className="d-flex justify-content-center">
                                <Col lg={8} >
                                
                                    
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                                        </div>
                                        <div>
                                        <h5>All Done</h5>
                                        <p className="text-muted">
                                                No Plan found
                                        </p>
                                        </div>
                                    </div>
                              
                                </Col>
                            </Row>
                                </>)}
                                </CardBody>
                            </Card>
                            </Col>
                        </Row>
                           

                    </Container>
                </div>
            </>
        );
    }

export default TrainingPlan;